// Ornate title card with a progress bar, shown while state.loading is set. Loader steps that
// name a data file get a human label ('Decoding physical.grid.bin' → 'Charting terrain').

import { useServices } from './context.ts';
import { Icon } from './icons.tsx';
import { Frame } from './parts.tsx';

// First match wins; anything unmatched shows the loader's own label.
const STEP_LABELS: Array<[RegExp, string]> = [
  [/physical/i, 'Charting terrain'],
  [/human|countries|borders|pov/i, 'Drawing borders'],
  [/sites|cities|wonders|resources/i, 'Founding cities'],
  [/indicators|milestones/i, 'Tallying the yields'],
  [/events|ucdp|conflicts/i, 'Reading the chronicles'],
  [/control/i, 'Plotting front lines'],
  [/world\.json|sources/i, 'Convening the diplomats'],
];

function stepLabel(raw: string): string {
  return STEP_LABELS.find(([re]) => re.test(raw))?.[1] ?? raw;
}

export function LoadingScreen() {
  const { state } = useServices();
  const loading = state.loading.value;
  if (!loading) {
    return null;
  }

  const pct = loading.total > 0 ? Math.min(1, loading.done / loading.total) : 0;
  return (
    <div class="wc-modal wc-loading" role="progressbar" aria-valuemin={0} aria-valuemax={loading.total} aria-valuenow={loading.done}>
      <div class="wc-modal-bg" />
      <Frame large="large" class="wc-loading-card">
        <div class="wc-loading-emblem">
          <Icon name="globe" size={46} />
        </div>
        <h1 class="wc-title wc-loading-title">WorldCiv</h1>
        <div class="wc-loading-sub">The real world, one week per turn</div>
        <div class="wc-progress">
          <div class="wc-progress-fill" style={{ width: `${(pct * 100).toFixed(1)}%` }} />
          <div class="wc-progress-gem" style={{ left: `${(pct * 100).toFixed(1)}%` }} />
        </div>
        <div class="wc-loading-label">
          <span title={loading.label}>{stepLabel(loading.label)}</span>
          <span class="wc-num">
            {loading.done} / {loading.total}
          </span>
        </div>
      </Frame>
    </div>
  );
}
